/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const ThumbsUpIcon = /*#__PURE__*/ createSvgIcon(
  'ThumbsUpIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            d="M17.5 6.98c.375 0 .719.155 1.031.468.313.312.469.656.469 1.031v1.188c0 .11-.01.215-.031.312-.021.097-.052.188-.094.271l-2.48 5.813c-.124.291-.357.52-.697.687-.34.167-.67.25-.99.25L5.5 16.98v-10l4.875-4.876c.264-.264.566-.434.906-.51.34-.077.646-.038.917.114.27.153.444.4.52.74.077.34.074.712-.01 1.114L12 6.98h5.5zM7 7.603v7.875h8l2.5-5.812V8.479h-7.333l1.02-5.042L7 7.604zM2.5 16.98c-.43 0-.788-.147-1.073-.44A1.467 1.467 0 011 15.478v-7c0-.412.142-.765.427-1.06.285-.293.642-.44 1.073-.44h3v1.5h-3v7h3v1.5h-3z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  false
);

export default ThumbsUpIcon;
